import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import PageSelector from './PageSelector';
import SuiButton from '../../../../components/SoftButton';
import PropTypes from "prop-types";

const PageSelectorDialog = ({open, handleCloseDialog, dialogTitle, handleConfirm, 
    loading, t, option, setOption, numberOfPage, pageRange, setPageRange, direction, isValidPageRange}) => {

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent sx={{display: "flex", flexDirection: "column", gap: 2}}>
            <PageSelector
            option={option}
            setOption={(e) => setOption(e.target.value)}
            pageRange={pageRange}
            setPageRange={setPageRange}
            numberOfPage={numberOfPage}
        />
        </DialogContent>
        <DialogActions sx={{px: 3, pb: 2}}>
        <SuiButton variant="contained" color="light" onClick={handleCloseDialog} >
            {t("cancel")}
        </SuiButton>
        <SuiButton
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            disabled={loading || (option === "range" && !isValidPageRange)}
            sx={{ml: 1, mr:  (direction === 'rtl' ? 1 : 0),}}
        >
            {loading ? t("loading") : t("confirm")}
        </SuiButton>
        </DialogActions>
    </Dialog>
    )

}


PageSelectorDialog.propTypes = {
    open: PropTypes.bool,
    handleCloseDialog: PropTypes.func,
    dialogTitle: PropTypes.string,
    handleConfirm: PropTypes.func,
    loading: PropTypes.bool,
    t: PropTypes.func,
    option: PropTypes.string,
    setOption: PropTypes.func,
    numberOfPage: PropTypes.number,
    pageRange: PropTypes.string,
    setPageRange: PropTypes.func,
    direction: PropTypes.string,
    isValidPageRange: PropTypes.bool
};

export default PageSelectorDialog;